import { ReactNode } from 'react';
import { toast, ToastOptions } from 'react-toastify';

export const ToastContent = ({
  title,
  message,
}: {
  title: string;
  message?: string | ReactNode;
}) => (
  <div>
    <h2 style={{ fontWeight: 700, fontSize: 14, marginBottom: '0.25rem' }}>
      {title}
    </h2>
    <p style={{ fontSize: 14 }}>{message}</p>
  </div>
);

export const appToast = {
  error: (
    errStatus = '',
    errMsg?: string | ReactNode,
    options?: ToastOptions,
  ) =>
    toast.error(
      <ToastContent title={errStatus} message={errMsg || ''} />,
      options,
    ),
  warning: (
    errStatus = '',
    errMsg?: string | ReactNode,
    options?: ToastOptions,
  ) =>
    toast.warning(
      <ToastContent title={errStatus} message={errMsg || ''} />,
      options,
    ),
  success: (
    errStatus = '',
    errMsg?: string | ReactNode,
    options?: ToastOptions,
  ) =>
    toast.success(
      <ToastContent title={errStatus} message={errMsg || ''} />,
      options,
    ),
  info: (errStatus = '', errMsg?: string | ReactNode, options?: ToastOptions) =>
    toast.info(
      <ToastContent title={errStatus} message={errMsg || ''} />,
      options,
    ),
};
